import createReactClass from "create-react-class";

export default function(dependencies) {
    const Header = createReactClass({
        render() {
            var field = this.props.field;
            return  <div className="lz-header-wrapper">
                <div className="lz-header" dangerouslySetInnerHTML={{__html: field.state.value}} >
                </div>
            </div>;
        },
    });

    return {
        html: Header,
        config: {
            "ignored": true
        }
    };
};

